import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: any = {
  loading: false,
  isSuccess: false,
  response: null,
  error: null,
};

export const approvePayPeriodReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.APPROVE_PAY_PERIOD_LOADER:
      return { ...state, loading: true, isSuccess: false, error: null };

    case laborHoursConstant.APPROVE_PAY_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        isSuccess: true,
        response: action.payload?.data,
        error: null,
      };

    case laborHoursConstant.APPROVE_PAY_PERIOD_FAILURE:
      return { ...state, loading: false, isSuccess: false, error: action.payload };

    case laborHoursConstant.APPROVE_PAY_PERIOD_RESET:
      return intitialstate;

    default:
      return state;
  }
};
